(function (angular) {
    'use strict';

    angular
        .module('app.purchase')
        .controller('app.purchase.restartPurchaseModalController', [
            '$scope',
            '$state',
            '$sessionStorage',
            restartPurchaseModalController
        ]);

    function restartPurchaseModalController($scope, $state, session) {
        var vm = this;
        vm.restart = restart;
        vm.maxPurchaseTime = "30";
        try {
            if (environment.maxPurchaseTime && parseInt(environment.maxPurchaseTime) > 0) {
                vm.maxPurchaseTime = environment.maxPurchaseTime;
            }
        }
        catch (error) {}

        function restart() {
            delete session.session;
            $state.go('app.purchase.plans');
        }
    }

})(angular);
